module.exports = __webpack_public_path__ + "static/media/15UN-Habitat1.e5e953a0.jpg";